/**
 * @description check ingore url for loading in interceptor
 * @param req requst
 */
export function IsIgnoreUrlForLoading(req) {
  if (
    !(req.url.includes('public'))) {
    return true;
  } else {
    return false;
  }
}
